import { useState, useCallback } from 'react';

const useChatState = () => {
  const [messages, setMessages] = useState([]);
  const [sessionId, setSessionId] = useState(null);
  const [currentSessionTitle, setCurrentSessionTitle] = useState("New chat");
  const [currentContext, setCurrentContext] = useState(null);
  const [queryData, setQueryData] = useState(null);
  const [chartConfig, setChartConfig] = useState(null);
  const [chartConfigs, setChartConfigs] = useState(null); 
  const [responseType, setResponseType] = useState(null);
  const [sqlQuery, setSqlQuery] = useState(null);
  const [recordCount, setRecordCount] = useState(0);
  const [connectionStatus, setConnectionStatus] = useState("disconnected");
  const [isTyping, setIsTyping] = useState(false);
  const [sqlQueries, setSqlQueries] = useState(null); 

  const initializeChat = useCallback(() => {
    const newSessionId = "session_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
    setSessionId(newSessionId);
    setConnectionStatus("connected");
    setCurrentSessionTitle("New chat");
    setQueryData(null);
    setChartConfig(null);
    setChartConfigs(null); // NEW
    setResponseType(null);
    setSqlQuery(null);
    setSqlQueries(null); 
    setRecordCount(0);
    setMessages([{
      id: 1,
      type: "bot",
      content: "Hello! I'm your rock tool report assistant. How can I assist you today?",
      timestamp: new Date(),
      sessionId: newSessionId, 
    }]);
  }, []);

  const addMessage = useCallback((message) => {
    setMessages(prev => [...prev, message]);
  }, []);

  const updateMessage = useCallback((messageId, updates) => {
    setMessages(prev => prev.map(msg =>
      msg.id === messageId ? { ...msg, ...updates } : msg
    ));
  }, []);

  const getConnectionStatusColor = useCallback(() => {
    switch (connectionStatus) {
      case "connected": return "bg-green-500";
      case "sending": return "bg-yellow-500";
      case "receiving": return "bg-blue-500";
      case "error": return "bg-red-500";
      default: return "bg-gray-500";
    }
  }, [connectionStatus]);

  const getConnectionStatusText = useCallback(() => {
    switch (connectionStatus) {
      case "connected": return recordCount > 0 ? `Connected • ${recordCount} records` : "Connected";
      case "sending": return "Analyzing query...";
      case "receiving": return "Processing data...";
      case "error": return "Connection Error";
      default: return "Disconnected";
    }
  }, [connectionStatus, recordCount]);

  return {
    // State
    messages,
    sessionId,
    currentSessionTitle,
    currentContext,
    queryData,
    chartConfig,
    chartConfigs, // NEW
    responseType,
    sqlQuery, // DEPRECATED
    sqlQueries,
    recordCount,
    connectionStatus,
    isTyping,
    
    // Setters
    setMessages,
    setSessionId,
    setCurrentSessionTitle,
    setCurrentContext,
    setQueryData,
    setChartConfig,
    setChartConfigs, // NEW
    setResponseType,
    setSqlQuery, // DEPRECATED
    setSqlQueries,
    setRecordCount,
    setConnectionStatus,
    setIsTyping,
    
    // Actions
    initializeChat,
    addMessage,
    updateMessage,
    getConnectionStatusColor,
    getConnectionStatusText
  };
};

export default useChatState;